import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { EXTENSION_TYPE_NAME } from './constants';
import Component from './components/MuroBlock';
export const DaMuro = Node.create({
    name: EXTENSION_TYPE_NAME,
    group: 'block',
    inline: false,
    draggable: false,
    addStorage () {
        return {};
    },
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    addAttributes () {
        return {
            prompt: {
                default: null
            }
        };
    },
    parseHTML () {
        return [];
    },
    renderHTML ({ HTMLAttributes: { deviation, width, alignment, link } }) {
        return [
            'span'
        ];
    },
    addNodeView () {
        return ReactNodeViewRenderer(Component);
    },
    addCommands () {
        return {
            daMuroStartDrawing: ()=>({ editor, dispatch, tr, commands })=>{
                    if (dispatch) {
                        commands.insertContent({
                            type: this.name,
                            attrs: {}
                        });
                    }
                    return true;
                },
            daMuroUseDrawing: (deviation)=>({ editor, chain, dispatch, tr, commands, state })=>{
                    if (dispatch) {
                        return chain().daMuroDelete().daDeviationAddDeviation(deviation).run();
                    }
                    return true;
                },
            daMuroDelete: ()=>({ editor, chain, dispatch, commands, state })=>{
                    if (dispatch) {
                        const { selection } = state;
                        const node = selection.node;
                        if (node) {
                            const { tr } = state;
                            tr.deleteRange(selection.from, selection.to);
                            dispatch(tr);
                        }
                        return true;
                    }
                    return true;
                }
        };
    }
});

//# sourceMappingURL=muro.js.map